interface BuyLinkProps {
  href: string,
}

export function BuyLink({ href }: BuyLinkProps) {
  return (
    <span>🛒 
      <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: '#4da6ff',
        textDecoration: 'underline',
        fontWeight: 'bold'
      }}
      >
      Buy
    </a>
    </span>
  );
}
